module.exports = __webpack_public_path__ + "img/box_natgas_grey.f2eb4160.png";